import React, { useState, useEffect, useMemo } from 'react'
import { useProgress } from 'drei'
import BarLoader from 'react-spinners/BarLoader'
import classNames from 'classnames'
import useStore from '../../store'
import BlurText from '../blurText'
import './Loader.css'

const Loader = ({ fullscreen = false, centerScreen = false }) => {
  const [hasLoaded, setLoaded] = useState([])
  const [audiosLoaded, setAudiosLoaded] = useState([])
  const [skipLoading, setSkipLoading] = useState(false)
  const { active, item, errors } = useProgress()
  const { audios } = useStore()

  useEffect(() => { setTimeout(() => setSkipLoading(false), 10000) }, [])

  useEffect(() => {
    if (errors.length) console.error('load fail', errors)
  }, [errors])

  useEffect(() => {
    const keys = Object.keys(audios)

    const onLoadAudio = (e) => {
      setAudiosLoaded((prev) => [...new Set([...prev, e.target.src])])
    }

    const audiosElements = keys
      .map((key) => {
        const audioClick = audios[key].click
        const audioHover = audios[key].hover

        return [audioClick, audioHover]
      })
      .flat()

    audiosElements.forEach((audio) => {
      audio.load()
      audio.addEventListener('canplaythrough', onLoadAudio, false)
    })

    return () => {
      audiosElements.forEach((audio) => {
        audio.removeEventListener('canplaythrough', onLoadAudio, false)
      })
    }
  }, [audios])

  useEffect(() => setLoaded((prev) => [...new Set([...prev, item])]), [item])

  const inProgress = useMemo(() => {
    if (skipLoading) return false
    if (active) return true

    const canvasLoading = hasLoaded.length <= 19 // MAX 23
    const audiosLoading = audiosLoaded.length <= 10 // MAX 16

    return canvasLoading || audiosLoading
  }, [hasLoaded.length, audiosLoaded.length, active, skipLoading])

  if (!inProgress) return null

  const loaderClasses = classNames(
    'loader-center',
    {
      'loader-content': fullscreen,
      'loader-center-screen': centerScreen
    },
  )

  return (
    <div className={loaderClasses}>
      <BarLoader color="#b1015a" loading />
      <div className="loader-text">
        <BlurText active>Loading...</BlurText>
      </div>
    </div>
  )
}

export default Loader
